import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getActiveCustomVodLimit } from '../../services/VideoService';
import { ActiveCustomVodLimitResponse } from '../../types/Videos';

function useGetActiveCustomVodLimit(
  fleetId: string,
  deviceId: string | undefined,
  enabled = true,
): UseQueryResult<ActiveCustomVodLimitResponse> {
  return useQuery(
    ['active-custom-vod-limit', fleetId, deviceId],
    async (): Promise<ActiveCustomVodLimitResponse> => getActiveCustomVodLimit(
      fleetId,
      deviceId as string,
    ),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: enabled && !!fleetId && !!deviceId,
    },
  );
}

export default useGetActiveCustomVodLimit;
